import Vue from 'vue';
import Vuex from 'vuex';
import app from './modules/app';
import user from './modules/user';
import company from './modules/company';
import config from './modules/config';
import area from './modules/area';
import enterpriseRecruit from './modules/enterprise-recruit';
import createLogger from 'vuex/dist/logger';
import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';
const plugins = debug ? [ createLogger(), createPersistedState({ paths: ['app', 'enterpriseRecruit', 'config', 'area'], storage: window.sessionStorage }) ] : [createPersistedState({ paths: ['app', 'enterpriseRecruit', 'config', 'area'], storage: window.sessionStorage })];

export default new Vuex.Store({
  modules: { app, user, enterpriseRecruit, company, config, area },
  strict: debug,
  plugins
});



// WEBPACK FOOTER //
// ./src/store/index.js